import type { SVGProps } from 'react';

export function HighFiveIcon({
  className,
  width,
  height,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width={width ?? '145'}
      height={height ?? '125'}
      className={className}
      viewBox='0 0 145 125'
      fill='none'
    >
      <g clipPath='url(#clip0_4656_40836)'>
        <path
          d='M34.2446 68.437L21.9437 34.2722C20.7246 31.0659 22.3345 27.5068 25.6012 26.3255C28.8678 25.1289 32.5722 26.7397 33.7913 29.9613L46.1547 64.3256'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M28.6494 90.2982C30.8532 96.45 26.383 92.7221 26.383 92.7221C26.383 92.7221 13.8477 81.5231 9.97149 79.7895C9.94023 79.7742 9.89334 79.7588 9.86208 79.7435C4.12585 77.2582 -1.03207 84.4379 3.01612 89.1476C5.9702 92.5994 27.9304 114.353 34.5419 118.112C34.5419 118.112 45.2329 127.363 62.1134 121.548C71.8196 118.204 76.6962 111.715 79.2283 105.532'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M28.6499 90.2982L13.2387 47.4656C12.0195 44.2593 13.6294 40.7002 16.8961 39.5189C20.1628 38.3223 23.8671 39.9331 25.0862 43.1548'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M60.6602 67.2251L53.1109 45.9929L53.064 45.8395L48.9845 34.4256C47.953 31.7716 45.2802 30.2375 42.5293 30.4216C41.951 30.4523 41.3571 30.575 40.7788 30.7744C40.5443 30.8511 40.3411 30.9739 40.1692 31.0659C37.3089 32.462 35.9647 35.7296 37.1213 38.7058'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M53.1107 45.9929C51.8916 42.7866 53.5015 39.2274 56.7682 38.0462C60.0348 36.8495 63.7392 38.4604 64.9583 41.682L79.9475 84.4226C83.7613 95.0233 79.6818 104.581 79.1191 105.854'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M110.754 61.917L123.055 27.7522C124.274 24.5459 122.664 20.9867 119.397 19.8055C116.131 18.6089 112.426 20.2197 111.207 23.4413L98.8438 57.8056'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M75.8828 111.592C77.8835 112.942 80.228 114.123 82.9163 115.044C99.7812 120.858 110.488 111.592 110.488 111.592C117.084 107.849 139.059 86.0794 141.998 82.6276C146.046 77.9332 140.888 70.7382 135.136 73.2388C135.105 73.2695 135.074 73.2695 135.043 73.3002C131.198 75.0338 118.647 86.2328 118.647 86.2328C118.647 86.2328 114.161 89.9454 116.365 83.8089'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M116.365 83.7936L131.776 40.961C132.996 37.7547 131.386 34.1955 128.119 33.0142C124.852 31.8176 121.148 33.4284 119.929 36.6501'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M84.3545 60.7204L91.9038 39.4882L91.9507 39.3348L96.0301 27.9209C97.0617 25.2669 99.7345 23.7328 102.485 23.9169C103.064 23.9476 103.658 24.0703 104.236 24.2697C104.47 24.3464 104.674 24.4692 104.845 24.5612C107.706 25.9573 109.05 29.2249 107.893 32.2011'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M71.3662 59.9227L80.0253 35.162C81.26 31.9403 84.9487 30.3295 88.2154 31.5108C91.4977 32.7228 93.1076 36.2666 91.8572 39.4882'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M66.7711 16.7066L65.0361 1.53412'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M57.2833 20.4651L44.9043 9.00528'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M76.9463 18.9924L86.5275 5.87567'
          stroke='#262626'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_4656_40836'>
          <rect width='145' height='125' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
